export const LANGUAGE = {
  SV: "sv",
  EN: "en",
} as const;

export type Language = typeof LANGUAGE[keyof typeof LANGUAGE];

export interface PdfStrings {
  frontPage: {
    title: string;
    description: string;
    didYouKnow: {
      title: string;
      description: string;
      link: {
        label: string;
        url: string;
      }
    };
    contactUs: {
      title: string;
      description: string;
      url: string;
    };
    missingSomething: {
      title: string;
      description: string;
      link: {
        label: string;
        url: string;
      }
    };
    serviceAndSupport: {
      title: string;
      description: string;
      url: string;
    };
  };
  orderPage: {
    reportTitle: string;
    orderSection: string;
    orderNumber: string;
    customer: string;
    address: string;
    installations: string;
    serviceRequest: {
      title: string;
      createServiceRequest: string;
      scanQrToSimplify: string;
      clickHere: string;
      url: string;
    };
    companyDescription: string;
  };
  checklistPage: {
    installation: string;
    selfInspection: string;
    functionCheckDone: string;
    documentationDone: string;
  };
  inspectionsSection: {
    title: string;
    withCustomerOnSite: string;
    withoutCustomerOnSite: string;
    customerName: string;
    approvedInstallations: string;
    personContacted: string;
    phone: string;
    time: string;
    comment: string;
  };
  productsSection: {
    title: string;
  };
  productDetails: {
    serialNumber: string;
    macAddress: string;
    macAddressWifi: string;
    networkPort: string;
    assetNumber: string;
    theftMarking: string;
    ipAddress: string;
    username: string;
    password: string;
    firmware: string;
    other: string;
  };
  imagesSection: {
    title: string;
  };
  footer: {
    url: string;
  };
}
